/**
 * "Meus chamados": the traveler's support tickets (web-chat `/support`).
 * A ticket is a conversation that went through the support desk, or an AI
 * conversation with an unresolved pending item. `status` is derived by the
 * conversation service; clients only render it.
 */
import { z } from 'zod';

import { MessageAuthorSchema } from './message_author.js';
import { ConversationIdSchema } from './message_envelope.js';

export const SupportTicketStatusSchema = z.enum(['your_turn', 'waiting', 'resolved']);
export type SupportTicketStatus = z.infer<typeof SupportTicketStatusSchema>;

export const SupportTicketSchema = z
  .object({
    conversationId: ConversationIdSchema,
    title: z.string().nullable(),
    lastMessageAt: z.iso.datetime(),
    lastMessagePreview: z.string().nullable(),
    /** Who wrote the latest message — the row says "Você:" or names the team. */
    lastMessageAuthor: MessageAuthorSchema.optional(),
    status: SupportTicketStatusSchema,
    /** The chat is with the Zendesk desk right now — "Abrir chamado" goes here. */
    withDesk: z.boolean(),
    /** Oldest unresolved pending notification of this conversation. */
    pendingSince: z.iso.datetime().optional(),
  })
  .strict();
export type SupportTicket = z.infer<typeof SupportTicketSchema>;
